/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('SimulationDataServiceApi', ($http, ApiErrorService) => {
    return {
        getModels: getModels,
        getShortModels: getShortModels,
        getModelById: getModelById,
        getModelsForSimulator: getModelsForSimulator,
        getModelsForSimulatorShort: getModelsForSimulatorShort,
        getShortModelsWithJsonForSimulator: getShortModelsWithJsonForSimulator,
        getShortModelWithJsonByUID: getShortModelWithJsonByUID,
        getModelsForType: getModelsForType,
        getSimulatorsForModel: getSimulatorsForModel,
        saveModel: saveModel,
        saveModelsForSimulator: saveModelsForSimulator,
        deleteModel: deleteModel,
        getType: getType,
        getTypes: getTypes,
        getFormlyFilenames: getFormlyFilenames,
        getTypesForSimulator: getTypesForSimulator,
        saveType: saveType,
        deleteType: deleteType,
        getInstances: getInstances,
        getInstancesForSimulator: getInstancesForSimulator,
        getUpdatedInstancesForSimulatorAndUser: getUpdatedInstancesForSimulatorAndUser,
        getShortInstancesForSimulator: getShortInstancesForSimulator,
        getShortInstanceForUser: getShortInstanceForUser,
        saveInstance: saveInstance,
        resetInstance: resetInstance,
        saveModelsForLibrary: saveModelsForLibrary,
        getLibrariesForSimulator: getLibrariesForSimulator,
        getRegisteredModelLibraries: getRegisteredModelLibraries,
        getAvailableModelLibraries: getAvailableModelLibraries,
        setActiveModelLibrary: setActiveModelLibrary,
        saveLibrariesForSimulator: saveLibrariesForSimulator,
        getLibraryTypes: getLibraryTypes,
        saveLibraryType: saveLibraryType,
        deleteLibraryType: deleteLibraryType,
        getLibraryTypesForSimulator: getLibraryTypesForSimulator,
        saveLibraryTypesForSimulator: saveLibraryTypesForSimulator,
        getLibraries: getLibraries,
        getLibraryById: getLibraryById,
        saveLibrary: saveLibrary,
        deleteLibrary: deleteLibrary,
        syncSimulationData: syncSimulationData,
        getSimulationDataLibraryStructures: getSimulationDataLibraryStructures
    };
    function getModels() {
        return $http.get(`api/SimulationData/Model`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getShortModels() {
        return $http.get(`api/SimulationData/ShortModel`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getModelById(modelId) {
        return $http.get(`api/SimulationData/Models/${modelId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getModelsForSimulator(simulatorId) {
        return $http.get(`api/SimulationData/Model/Simulator/${simulatorId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getModelsForSimulatorShort(simulatorId) {
        return $http.get(`api/SimulationData/ShortModel/Simulator/${simulatorId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getShortModelsWithJsonForSimulator(simulatorId) {
        return $http.get(`api/SimulationData/ShortModelWithJson/Simulator/${simulatorId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getShortModelWithJsonByUID(libraryTypeUid, libraryUid, modelUid, userId, simulatorId) {
        return $http.get(`api/SimulationData/LibraryType/${encodeURIComponent(libraryTypeUid)}/Library/${encodeURIComponent(libraryUid)}/ShortModelWithJson/${encodeURIComponent(modelUid)}?userId=${userId}&simulatorId=${simulatorId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getModelsForType(simulationDataTypeId) {
        return $http.get(`api/SimulationData/Type/${simulationDataTypeId}/Model`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getSimulatorsForModel(simulationDataModelId) {
        return $http.get(`api/SimulationData/Model/${simulationDataModelId}/Simulator`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function saveModel(simulationDataModel) {
        return $http.post(`api/SimulationData/Model`, simulationDataModel)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function saveModelsForSimulator(simulatorId, simulationDataModels) {
        return $http.post(`api/SimulationData/Model/Simulator/${simulatorId}`, simulationDataModels)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function deleteModel(simulationDataModelId) {
        return $http.post(`api/SimulationData/Model/${simulationDataModelId}/Delete`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getType(simulationDataTypeId, simulatorId, userId) {
        return $http.get(`api/SimulationData/Type/${simulationDataTypeId}?simulatorId=${simulatorId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTypes() {
        return $http.get(`api/SimulationData/Type`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getFormlyFilenames() {
        return $http.get(`api/SimulationData/Type/FormlyFilenames`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTypesForSimulator(simulatorId) {
        return $http.get(`api/SimulationData/Type/Simulator/${simulatorId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function saveType(simulationDataType) {
        return $http.post(`api/SimulationData/Type`, simulationDataType)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function deleteType(simulationDataTypeId) {
        return $http.post(`api/SimulationData/Type/${simulationDataTypeId}/Delete`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getInstances(userId) {
        return $http.get(`api/SimulationData/Instance?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getInstancesForSimulator(simulatorId, userId) {
        return $http.get(`api/SimulationData/Instance/Simulator/${simulatorId}?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getUpdatedInstancesForSimulatorAndUser(simulatorId, userId) {
        return $http.get(`api/SimulationData/Simulator/${simulatorId}/UpdatedInstanceUIDs?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getShortInstancesForSimulator(simulatorId, userId) {
        return $http.get(`api/SimulationData/ShortInstance/Simulator/${simulatorId}?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getShortInstanceForUser(simulatorId, modelId, userId) {
        return $http.get(`api/SimulationData/ShortInstanceById/Simulator/${simulatorId}?modelId=${modelId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function saveInstance(simulationDataInstance) {
        return $http.post(`api/SimulationData/Instance`, simulationDataInstance)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function resetInstance(simulationDataInstanceId, simulatorId, userId) {
        return $http.post(`api/SimulationData/Instance/${simulationDataInstanceId}/Reset?simulatorId=${simulatorId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function saveModelsForLibrary(simulationDataLibraryId, simulationDataModelIds) {
        return $http.post(`api/SimulationData/Library/${simulationDataLibraryId}/Model?simulationDataModelIds=${simulationDataModelIds}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getLibrariesForSimulator(simulatorId) {
        return $http.get(`api/SimulationData/Library/Simulator/${simulatorId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getRegisteredModelLibraries(simulatorId) {
        return $http.get(`api/SimulationData/RegisteredModelLibraries/Simulator/${simulatorId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAvailableModelLibraries(simulatorId, userId) {
        return $http.get(`api/SimulationData/AvailableModelLibraries/Simulator/${simulatorId}/${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function setActiveModelLibrary(simulatorId, userId, libraryTypeUid, libraryUid) {
        return $http.post(`api/SimulationData/ActiveModelLibraries/Simulator?simulatorId=${simulatorId}&userId=${userId}&libraryTypeUid=${encodeURIComponent(libraryTypeUid)}&libraryUid=${encodeURIComponent(libraryUid)}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function saveLibrariesForSimulator(simulatorId, simulationDataLibraryIds) {
        return $http.post(`api/SimulationData/Library/Simulator/${simulatorId}?simulationDataLibraryIds=${simulationDataLibraryIds}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getLibraryTypes() {
        return $http.get(`api/SimulationData/Library/Type`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function saveLibraryType(simulationDataLibraryType) {
        return $http.post(`api/SimulationData/Library/Type`, simulationDataLibraryType)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function deleteLibraryType(simulationDataLibraryTypeId) {
        return $http.post(`api/SimulationData/Library/Type/${simulationDataLibraryTypeId}/Delete`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getLibraryTypesForSimulator(simulatorId) {
        return $http.get(`api/SimulationData/Library/Type/Simulator/${simulatorId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function saveLibraryTypesForSimulator(simulatorId, simulationDataLibraryTypeIds) {
        return $http.post(`api/SimulationData/Library/Type/Simulator/${simulatorId}?simulationDataLibraryTypeIds=${simulationDataLibraryTypeIds}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getLibraries() {
        return $http.get(`api/SimulationData/Library`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getLibraryById(libraryId) {
        return $http.get(`api/SimulationData/Libraries/${libraryId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function saveLibrary(simulationDataLibrary) {
        return $http.post(`api/SimulationData/Library`, simulationDataLibrary)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function deleteLibrary(simulationDataLibraryId) {
        return $http.post(`api/SimulationData/Library/${simulationDataLibraryId}/Delete`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function syncSimulationData(simulatorId, userId) {
        return $http.post(`api/SimulationData/Sync?simulatorId=${simulatorId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getSimulationDataLibraryStructures(simulatorId, userId) {
        return $http.get(`api/SimulationData/Libraries/Simulator/${simulatorId}/structure?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
